/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ReportDto } from '../../models/report-dto';

export interface ReportControllerCreate$Params {
      body: ReportDto
}

export function reportControllerCreate(http: HttpClient, rootUrl: string, params: ReportControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<ReportDto>> {
  const rb = new RequestBuilder(rootUrl, reportControllerCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ReportDto>;
    })
  );
}

reportControllerCreate.PATH = '/api/report';
